import { render, staticRenderFns } from "./MenusItem.vue?vue&type=template&id=32f9da7f"
import script from "./MenusItem.vue?vue&type=script&lang=js"
export * from "./MenusItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports